import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Pagination from '../../../../Pagination/Pagination';

export const BodySpecialPagination = ({className, bodyId, filters, onFilterChange, allowInput}) => {
	const maxVal = useSelector((state) => state.bodiesSpecial.metadata[bodyId]?.pages);

	const handlePageChange = useCallback((page) => {
		onFilterChange('page', page);
	}, []);

	const handleOnPageSizeChange = useCallback(
		(option) => {
			if (option !== filters.pageSize) {
				onFilterChange('pageSize', option);
			}
		},
		[filters]
	);

	return (
		<StyledBodySpecialPagination className={className}>
			<Pagination
				page={filters.page}
				optionsPerPage={filters.pagingOptions}
				onPageChanged={handlePageChange}
				onPageSizeChanged={handleOnPageSizeChange}
				pageSize={filters.pageSize}
				pageCount={maxVal}
				allowInput={allowInput}
			/>
		</StyledBodySpecialPagination>
	);
};

BodySpecialPagination.propTypes = {
	className: PropTypes.string,
	bodyId: PropTypes.number.isRequired,
	filters: PropTypes.instanceOf(Object),
	onFilterChange: PropTypes.func.isRequired,
	allowInput: PropTypes.bool
};

BodySpecialPagination.defaultProps = {
	className: 'StyledBodySpecialPagination body-special-pagination',
	allowInput: true
};

export default BodySpecialPagination;

const StyledBodySpecialPagination = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 0 var(--px-20) 0;
	font-size: var(--px-14);
	line-height: var(--px-32);
	& * {
		font-size: var(--px-14) !important;
	}
	.PagingShowLabel {
		display: inline-flex;
		font-size: var(--px-14);
	}
	.motif-pagination {
		.motif-pagination-select {
			.motif-dropdown-menu {
				left: var(--px-2) !important;
				min-width: var(--px-50) !important;
			}
		}
		.motif-dropdown-trigger .motif-icon-button,
		.motif-icon-button,
		.motif-pagination-count {
			min-width: var(--px-32) !important;
			height: var(--px-32) !important;
		}
		.motif-pagination-count {
			margin: 0 var(--px-14) !important;
			.motif-number-of-pages {
				margin-top: var(--px-2) !important;
				span {
					min-width: var(--px-8);
					font-size: var(--px-14);
					font-weight: 700;
				}
			}
			.motif-pagination-current-page {
				min-width: var(--px-9) !important;
				font-size: var(--px-14) !important;
				font-weight: 700;
			}
			.ref-input-elem {
				font-size: var(--px-14) !important;
				font-weight: 700;
			}
		}
		.motif-dropdown-trigger .motif-icon-button svg,
		.motif-icon-button svg,
		.motif-pagination-button svg {
			width: var(--px-24) !important;
			height: var(--px-24) !important;
			padding-top: var(--px-2) !important;
		}
	}
`;
